import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import { Col, Row, Spin } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Account } from '~/types';
import AccountAutocompleteItem from './AccountAutocompleteItem';
import theme from '~/theme';
import { getCurrentBalance } from '~/utils/amounts';

interface Props {
  account?: Account;
  loading: boolean;
  onClick: () => void;
  className?: string;
  [key: string]: any;
}

const SpinIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const ExpandIcon = <DownOutlined style={{ paddingLeft: 2, marginTop: 6 }} />;

const AccountAutocompleteField: FC<Props> = (props) => {
  const { account, loading, className, onClick, disabled } = props;

  const [t] = useTranslation();
  return (
    <div
      className={`${className} ${disabled ? 'AccountAutocompleteField-Disabled' : ''}`}
      onClick={onClick}
    >
      {loading ? (
        <div className="AccountAutocompleteField-Spin">
          <Spin indicator={SpinIcon} />
        </div>
      ) : account ? (
        <AccountAutocompleteItem
          title={<span>{account.alias || '...'}</span>}
          subtitle={<span>{account.number}</span>}
          amount={getCurrentBalance(account)?.amount}
          suffix={ExpandIcon}
        />
      ) : (
        <Row
          gutter={[8, 0]}
          wrap={false}
          align="middle"
          className={`AccountAutocompleteField-Placeholder`}
        >
          <Col flex="auto">{t('Select account')}</Col>
          <Col>{ExpandIcon}</Col>
        </Row>
      )}
    </div>
  );
};

export default styled(AccountAutocompleteField)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 4px 8px 4px 14px;
  background-color: white;
  border-radius: ${theme.borderRadiusBase}px;
  border: 1px solid ${theme.borderColor};

  .AccountAutocompleteField-Spin,
  .AccountAutocompleteField-Placeholder {
    height: 36px;
    line-height: 36px;
  }
  .AccountAutocompleteField-Placeholder {
    opacity: 0.5;
    width: 100%;
  }
  &.AccountAutocompleteField-Disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
